import React from 'react'
import styled from 'styled-components'

import { getEulaUrl } from 'containers/EULAModal/constants'
import { WORKDAYS_OPTIONS } from 'containers/Settings/General/constants'

import Checkbox from 'components/lib/DesignSystem/Checkbox'
import Select from 'components/lib/DesignSystem/Select'
import LabelText from 'components/lib/LabelText'
import { countryOptions, timezoneOptions } from 'components/pages/settings/general/selectOptions'
import { onMobile } from 'components/styles/utils/breakpoints'

const customStyle = {
  width: '260px',
}

const FirstSettingsForm = ({
  className,
  timezone = '',
  country = null,
  workDays = '',
  onChange,
  eula = false,
  eulaType,
}) => {
  const changeCheckbox = (event) => {
    const { name, checked } = event.target
    onChange(name, checked)
  }

  return (
    <div className={className}>
      <div className="form">
        <div>
          <LabelText text="Timezone" />
          <Select
            style={customStyle}
            className="rc-list-style"
            placeholder="Select Timezone"
            value={timezone}
            options={timezoneOptions}
            id="First_Login_Timezone"
            onSelect={(option) => onChange('timezone', option)}
          />
        </div>
        <div>
          <LabelText text="Country" />
          <Select
            style={customStyle}
            className="rc-list-style"
            placeholder="Select Country"
            value={country}
            options={countryOptions}
            id="First_Login_Country"
            onSelect={(option) => onChange('country', option)}
          />
        </div>
        <div>
          <LabelText text="Business Days" />
          <Select
            style={customStyle}
            className="rc-list-style"
            placeholder="Select Business Days"
            value={workDays}
            options={WORKDAYS_OPTIONS}
            id="First_Login_Business_Days"
            onSelect={(option) => onChange('workDays', option)}
            optionFilterProp="label"
          />
        </div>
      </div>

      <div className="checkbox_container">
        <Checkbox
          onChange={changeCheckbox}
          name="eula"
          checked={eula}
          label={
            <div>
              I hereby agree and consent to the{' '}
              <a
                id="First_Login_User_Agreement"
                href={getEulaUrl(eulaType)}
                target="_blank"
                rel="noopener noreferrer"
              >
                User Agreement
              </a>
              , its policies, and the{' '}
              <a
                id="First_Login_Privacy_Policy"
                href="https://ironscales.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </div>
          }
          id="First_Login_Form_Eula_Checkbox"
        />
      </div>
    </div>
  )
}

export default styled(FirstSettingsForm)`
  display: flex;
  flex-direction: column;
  /* @media screen and (max-width: ${(props) => props.theme.rcPhonePointMin}) {
     align-items: center;
  } */
  ${onMobile()} {
    align-items: center;
  }

  .form {
    width: 260px;
    display: flex;
    flex-direction: column;
    gap: 26px;
  }

  .checkbox_container {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: 40px;
  }
`
